module.exports = __webpack_public_path__ + "static/media/nl.3a453b84.svg";